import { Outlet, Navigate } from 'react-router-dom';
import { useAuthStore } from '../../store/authStore';

export default function AuthLayout() {
  const { isAuthenticated } = useAuthStore();
  
  // Si ya está autenticado, redirigir a juegos
  if (isAuthenticated) {
    return <Navigate to="/juegos" replace />;
  }
  
  return (
    <div className="min-h-screen flex items-center justify-center p-4">
      <Outlet />
    </div>
  );
}
